import React, { FC, useCallback, useEffect, useState } from 'react';
import Form, { FormSchema } from '../../form/Form';
import { Button, Card, Divider, message, Typography } from 'antd';
import './RequestPasswordRest.less';
import { useHistory } from 'react-router-dom';
import { useConnection, useUserInfo } from '../../connection/Application';
import { useQueryParam } from 'use-query-params';
const { Title } = Typography;

const schema: FormSchema = [
  {
    id: 'newPassword',
    name: 'New Password',
    type: 'password',
    options: {
      rules: [{ required: true, whitespace: true, message: 'Password is required' }],
    },
  },
  {
    id: 'reTypePassword',
    name: 'Re-Type Password',
    type: 'password',
    options: {
      dependencies: ['newPassword'],
      rules: [
        { required: true, whitespace: true, message: 'Password is required' },
        { validator: 'equals', to: 'newPassword', message: 'Same password required' },
      ],
    },
  },
];

const RestPassword: FC = () => {
  const history = useHistory();
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [token] = useQueryParam<string | undefined>('token');
  const user = useUserInfo();
  useEffect(() => {
    if (!token || token === '') {
      history.replace('/login');
    }
  }, [history, token]);
  useEffect(() => {
    if (user) {
      history.replace('/webux/my-goals');
    }
  }, [history, user]);
  const onSubmit = useCallback(
    (formData) => {
      setLoading(true);
      connection
        .post('users/password-reset', {
          password: formData.newPassword,
          token: token,
        })
        .then(() => {
          message.success('Password change successfully');
          history.replace('/login');
        })
        .catch((error) => {
          form.setFields([{ name: 'newPassword', errors: [error.message] }]);
        })
        .finally(() => setLoading(false));
    },
    [connection, form, history, token],
  );
  return (
    <div className="login">
      <Card className="login-card">
        <img src="../../images/logo.png" alt="logo" />
        <Divider orientation="center">
          <Title level={5}>Password Reset</Title>
        </Divider>
        <Form form={form} onFinish={onSubmit} layout="vertical">
          <Form.Items schema={schema} />
          <Button htmlType="submit" type="primary" block loading={loading}>
            Reset Password
          </Button>
        </Form>
        <Divider orientation="center" />
        <Button type="link" size="large" onClick={() => history.replace('/login')} block>
          login?
        </Button>
      </Card>
    </div>
  );
};

export default RestPassword;
// password-rest
